import styled from "styled-components";
import { colors, layout } from "../../utils/styles/theme";
import { motion } from "framer-motion";

export const Wrapper = styled(motion.div)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: ${layout.zIndex.modals};
`;

export const ProgressBar = styled.div`
  width: 100vw;
  height: 10rem;
`;
export const ProgressBarPercentage = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${colors.white};
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.4s, opacity 0.6s 1s;
`;
